import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeSkeletonModule } from 'se-fe-skeleton'
import { SeFeListModule } from 'se-fe-list'
import { SeFeListItemSkeletonComponent } from 'se-fe-list/skeleton'

@Component({
  selector: 'se-po-profile-contacts-skeleton',
  standalone: true,
  imports: [
    SeFeCardModule,
    SeFeCardHeaderSkeletonComponent,
    SeFeListModule,
    SeFeListItemSkeletonComponent,
    SeFeSkeletonModule
  ],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton
        seFeDataSize="section"
        [seFeDataAction]="true"
        [seFeDataHeavyBorder]="true"
        [seFeDataTitle]="true">
        </se-fe-card-header-skeleton>
      <se-fe-card-content>
        <se-fe-list>
          <se-fe-list-item-skeleton
            seFeDataSize="small"
            [seFeDataVisual]="true"
            [seFeDataTitle]="true"
            seFeDataSubtitle="text|medium|2">
          </se-fe-list-item-skeleton>
        </se-fe-list>
      </se-fe-card-content>
    </se-fe-card>
  `,
})
export class ProfileContactsSkeletonComponent {}
